import React from 'react';

const ExternalPaymentButton = ({ name, onClick, icon }) => (
  <button
    type="button"
    className="bg-neutral-800/50 p-2.5 rounded-lg flex items-center text-white/70 cursor-pointer hover:text-white w-full text-sm transition-colors"
    onClick={onClick}
  >
    {icon}
    {name}
  </button>
);

export const GoFundMeIcon = () => (
  <svg className="h-4 w-4 mr-2.5 flex-shrink-0" fill="none" viewBox="0 0 24 24" stroke="currentColor">
    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M4.318 6.318a4.5 4.5 0 000 6.364L12 20.364l7.682-7.682a4.5 4.5 0 00-6.364-6.364L12 7.636l-1.318-1.318a4.5 4.5 0 00-6.364 0z" />
  </svg>
);

export const PayPalIcon = () => (
  <svg className="h-4 w-4 mr-2.5 flex-shrink-0" fill="none" viewBox="0 0 24 24" stroke="currentColor">
    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M17 9V7a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2m2 4h10a2 2 0 002-2v-6a2 2 0 00-2-2H9a2 2 0 00-2 2v6a2 2 0 002 2zm7-5a2 2 0 11-4 0 2 2 0 014 0z" />
  </svg>
);

export default ExternalPaymentButton;
